import { Link } from 'react-router-dom'
import { useState } from 'react'

interface SidebarNavLinkProps {
    href: string
    icon: React.ComponentType<any>
    label: string
    isActive: boolean
    collapsed: boolean
}

export function SidebarNavLink({
    href,
    icon: Icon,
    label,
    isActive,
    collapsed
}: SidebarNavLinkProps) {
    const [hovered, setHovered] = useState(false)

    return (
        <Link
            to={href}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`
        flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200
        ${isActive
                    ? 'bg-digestr-500/10 text-digestr-500 border border-digestr-500/20'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }
      `}
        >
            <Icon
                size={collapsed ? 24 : 40}
                variant={isActive ? 'active' : hovered ? 'hover' : 'default'}
            />
            {!collapsed && <span>{label}</span>}
        </Link>
    )
}
